<lib-dialog
  #sendInvoiceTemplate="dialog"
  yesText="Download pdf"
  [onOkay]="exportToPDF"
>
  <ng-template>
    <div #sendInvoiceModal class="send-invoice-modal">
      <app-payment-confirmation
        [invoice]="invoice"
        [isConfirmationPage]="false"
      ></app-payment-confirmation>
    </div>
  </ng-template>
</lib-dialog>
<div class="portal-page-content">
  @if (loading) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  } @else {
    <div fxLayout="row" fxLayout.lt-md="column" class="payments-heading">
      <div fxFlex>
        <h2 class="header m-0">
          Payments
          <span class="header-summary"
            ><mat-icon>payments</mat-icon
            >{{ dataSource.rowCount | async }} payments</span
          >
        </h2>
      </div>
    </div>
    <app-payments-table
      [dataSource]="dataSource"
      [invoiceStatus]="invoiceStatus"
      [getInvoiceStatusIcon]="getInvoiceStatusIcon"
      (openInvoicePayment)="openInvoicePayment($event)"
      (copyInvoiceLink)="copyInvoiceLink()"
      [isPortal]="true"
    >
    </app-payments-table>
  }
</div>
